<template>
  <div class="container">
    <div class="login-box" @keydown.enter="submit">
      <div class="title">LAOT 账号注册</div>
      <div class="body">
        <div class="line">
          <div class="label">手机号</div>
          <a-input v-model:value="data.username" placeholder="请输入手机号" />
        </div>
        <div class="tip"/>
        <div class="line">
          <div class="label">邮箱</div>
          <a-input v-model:value="data.email" placeholder="请输入邮箱地址" />
        </div>
        <div class="tip">请填写真实邮箱地址，否则可能无法找回密码</div>
        <div class="line">
          <div class="label">密码</div>
          <a-input-password
            v-model:value="data.password"
            placeholder="请输入密码"
          />
        </div>
        <div class="tip"/>
        <div class="line">
          <div class="label">确认密码</div>
          <a-input-password
            v-model:value="data.confirmPassword"
            placeholder="请确认密码"
          />
        </div>
        <div class="tip"/>
        <div style="display: flex; flex-direction: row" v-if="needCaptcha">
          <vue-hcaptcha
            ref="captcha"
            @verify="onVerify"
            :sitekey="config.captchaKey"
          ></vue-hcaptcha>
        </div>
      </div>
      <div class="btn-group">
        <sc-btn type="primary" :handler="submit" text="注册" />
        <sc-btn
          type="link"
          text="已有账号，去登录"
          :handler="() => router.push('/login')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ScForm } from '@/models/ScForm';
import { useRouter } from 'vue-router';
import { tokenManager } from '@/util/token';
import { request } from '@/util/request';
import { user } from '@/models/User';
import { addBizRouter } from '@/router';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';
import config from '@/config';
import { message } from 'ant-design-vue';
import { ref } from 'vue';

const form = new ScForm();
const captcha = ref<InstanceType<typeof VueHcaptcha>>();
form.init();
const router = useRouter();
const data = form.data;
const needCaptcha = ref(false);

async function onVerify(token: string) {
  data.value.code = token;
}

async function submit() {
  if (needCaptcha.value && !data.value.code) {
    message.error('请先完成验证');
    return;
  }

  if (!/^1[0-9]{10}$/.test(form.data.value.username)) {
    message.error("手机号格式不正确")
    return;
  }

  if (form.data.value.password != form.data.value.confirmPassword) {
    message.error("确认密码与密码不一致")
    return;
  }

  const res = await request('/management/login/register', form.data.value, {
    noNeedLogin: true,
    onError: (err) => {
      if (err.type === 'biz') {
        captcha.value?.reset();
      }
    },
  });
  if (res) {
    tokenManager.set(res.token);
    user.set(res.user);
    await addBizRouter();
    const redirect = router.currentRoute.value.query?.redirect;
    const url = typeof redirect === 'string' ? redirect : '/';
    await router.replace(url);
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/images/bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-box {
    width: 500px;
    background: #ffffffef;
    margin: 0 auto;

    .title {
      padding: 20px;
      font-size: $font-size-large;
      font-weight: $font-weight-primary;
      border-bottom: 1px solid $color-content-border;
    }

    .body {
      padding: 10px 20px 20px;
    }

    .desc {
      margin-bottom: 20px;
    }

    .line {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-right: 20px;

      .label {
        text-align: right;
        width: 80px;
        margin-right: 20px;
      }
    }
    .tip {
      padding-left: 84px;;
      height: 25px;
      font-size: 12px;
      color: #666;
    }

    .btn-group {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-top: 1px solid $color-content-border;
      padding: $spacing-medium;
    }
  }
}
</style>
